<template>
  <div>
    <div class="keyboard-box">
      <div class="u-tooltip">
        <div class="u-tooltip-item cancel" @click="onCancel">取消</div>
        <div class="u-tooltip-item u-tooltip-tips">车牌号键盘</div>
        <div @click="onConfirm" class="u-tooltip-item submit">完成</div>
      </div>
      <div class="u-keyboard">
        <div class="u-keyboard-grids">
          <div v-if="!isabc">
            <div
              class="u-keyboard-grids-item"
              v-for="(item, index) in areaList"
              :key="index"
            >
              <div
                class="u-keyboard-grids-btn"
                v-for="i in areaList[index]"
                :key="i"
                @click="checkThis(1, i)"
                style="width: 62rpx;height: 80rpx;"
              >
                {{ i }}
              </div>
            </div>
          </div>
          <div v-else>
            <div
              class="u-keyboard-grids-item"
              v-for="(item, index) in EngKeyBoardList"
              :key="index"
            >
              <div
                class="u-keyboard-grids-btn"
                v-for="i in EngKeyBoardList[index]"
                :key="i"
                @click="checkThis(2, i)"
                style="width: 62rpx;height: 80rpx;"
              >
                {{ i }}
              </div>
            </div>
          </div>
          <div class="u-keyboard-change" @click="changeCarInputMode">
            <span v-if="!isabc">ABC</span>
            <span v-else>省份</span>
          </div>
          <div class="u-keyboard-back" @click="backspace()">
            <van-image class="backward" :src="require('../static/img/backspace.png')"></van-image>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isabc: false, // 字母键盘是否弹起
      areaList: [
        ["京", "沪", "粤", "津", "冀", "豫", "云", "辽", "黑", "湘"],
        ["皖", "鲁", "苏", "浙", "赣", "鄂", "桂", "甘", "晋", "陕"],
        ["蒙", "吉", "闽", "贵", "渝", "川", "青", "琼", "宁", "挂"],
        ["藏", "港", "澳", "新", "使", "学"]
      ],
      EngKeyBoardList: [
        [1, 2, 3, 4, 5, 6, 7, 8, 9, 0],
        ["Q", "W", "E", "R", "T", "Y", "U", "I", "O", "P"],
        ["A", "S", "D", "F", "G", "H", "J", "K", "L", "Z"],
        ["X", "C", "V", "B", "N", "M"]
      ]
    };
  },
  methods: {
    backspace() {
      this.$emit("BackcarNo", 1);
    },
    changeCarInputMode() {
      this.isabc = !this.isabc;
    },
    // 输入完成
    onConfirm() {
      /* this.$store.commit('COiskeyboard', false) */
      this.$emit("setkeyboard", false);
    },
    // 取消输入
    onCancel() {
      /* this.$store.commit('COiskeyboard', false) */
      this.$emit("setkeyboard", false);
    },
    checkThis(type, v) {
      switch (type) {
        case 1:
          this.$emit("GetcarNo", v);
          this.isabc = true;
          break;
        case 2:
          this.$emit("GetcarNo", v);
          break;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.keyboard-box {
  position: relative;
  width: 100%;
  /* height: 512rpx; */
  z-index: 1003;
}
.u-keyboard {
  position: relative;
  z-index: 1003;
}
.u-tooltip {
  display: flex;
  justify-content: space-between;
  background-color: #ffffff;
}
.u-tooltip-item {
  color: #333333;
  text-align: center;
  padding: 10px 15px;
  font-size: 14px;
  &.submit {
    color: #2979ff;
  }
  &.cancel {
    color: #888888;
  }
}
.u-keyboard-grids {
  background: rgb(215, 215, 217);
  padding: 12px 0;
  position: relative;
  text-align: center;
}
.u-keyboard-grids-item {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 7px;
}
.u-keyboard-grids-btn {
  text-decoration: none;
  width: 31px;
  flex: 0 0 31px;
  height: 40px;
  display: inline-block;
  font-size: 18px;
  text-align: center;
  line-height: 40px;
  background-color: #fff;
  margin: 4px 3px;
  border-radius: 3px;
  box-shadow: 0 1px 0px #888992;
  font-weight: 500;
}
.u-keyboard-back {
  position: absolute;
  width: 48px;
  right: 11px;
  bottom: 16px;
  height: 40px;
  background-color: rgb(185, 188, 195);
  display: flex;
  align-items: center;
  border-radius: 4px;
  justify-content: center;
  box-shadow: 0 1px 0px #888992;
}
.u-keyboard-change {
  font-size: 12px;
  box-shadow: 0 1px 0px #888992;
  position: absolute;
  width: 48px;
  left: 11px;
  line-height: 1;
  bottom: 16px;
  height: 40px;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  border-radius: 4px;
  justify-content: center;
}
.u-keyboard-change > span {
  font-weight: bold;
  font-size: 15px;
}
.backward {
  width: 60%;
  height: 70%;
  filter: contrast(50%);
}
</style>
